

// // // import { useState } from "react";
// // // import { Link } from "react-router-dom";
// // // import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User, Eye, EyeOff } from "lucide-react";

// // // const innovatorTypes = [
// // //   { id: "startup", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
// // //   { id: "msme", icon: Building2, title: "MSME", subtitle: "Small & medium" },
// // //   { id: "student", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
// // //   { id: "researcher", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
// // //   { id: "industry", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
// // //   { id: "innovator", icon: User, title: "Innovator", subtitle: "Individual" },
// // // ];

// // // export default function Register() {
// // //   const [selectedType, setSelectedType] = useState("startup");
// // //   const [showPassword, setShowPassword] = useState(false);

// // //   // Check if GSTIN and DPIIT should be shown
// // //   const showBusinessFields = selectedType !== "student" &&
// // //     selectedType !== "researcher" &&
// // //     selectedType !== "innovator";

// // //   return (
// // //     <div className="min-h-screen bg-gray-50">
// // //       {/* Top bar */}
// // //       <header className="bg-white border-b border-gray-100">
// // //         <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
// // //           <Link to="/" className="flex items-center gap-3">
// // //             <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
// // //               <Layers className="text-white w-4 h-4" />
// // //             </div>
// // //             <div>
// // //               <p className="font-bold text-gray-900 leading-tight">
// // //                 APIC <span className="text-indigo-600">ProtoHub</span>
// // //               </p>
// // //               <p className="text-[10px] tracking-wide text-gray-500 leading-tight">
// // //                 ANDHRA PRADESH
// // //               </p>
// // //             </div>
// // //           </Link>

// // //           <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
// // //             <Link to="/facilities" className="hover:text-indigo-600">Explore Facilities</Link>
// // //             <a href="#machines" className="hover:text-indigo-600">Machines</a>
// // //             <a href="#how-it-works" className="hover:text-indigo-600">How It Works</a>
// // //             <Link to="/app/dashboard" className="hover:text-indigo-600">For Innovators</Link>
// // //             <Link to="/admin" className="hover:text-indigo-600">APIC Admin</Link>
// // //           </nav>
// // //           <p className="text-sm text-gray-600">
// // //             Already have an account?{" "}
// // //             <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
// // //               Sign in
// // //             </Link>
// // //           </p>
// // //         </div>
// // //       </header>

// // //       <main className="max-w-4xl mx-auto px-6 py-12">
// // //         <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
// // //           Create your ProtoHub account
// // //         </h1>
// // //         <p className="text-gray-600 mb-8">
// // //           Choose your innovator type to personalize your workspace.
// // //         </p>

// // //         {/* Innovator type cards */}
// // //         <div className="grid sm:grid-cols-3 gap-4 mb-8">
// // //           {innovatorTypes.map(({ id, icon: Icon, title, subtitle }) => {
// // //             const isSelected = selectedType === id;
// // //             return (
// // //               <button
// // //                 key={id}
// // //                 type="button"
// // //                 onClick={() => setSelectedType(id)}
// // //                 className={`text-left rounded-2xl border p-5 transition ${isSelected
// // //                     ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
// // //                     : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
// // //                   }`}
// // //               >
// // //                 <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
// // //                 <p className="font-bold">{title}</p>
// // //                 <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
// // //                   {subtitle}
// // //                 </p>
// // //               </button>
// // //             );
// // //           })}
// // //         </div>

// // //         {/* Form card */}
// // //         <form className="bg-white border border-gray-100 rounded-2xl p-8">
// // //           <div className="grid sm:grid-cols-2 gap-6 mb-6">
// // //             <Field label="Full name" placeholder="Arjun Reddy" />
// // //             <Field label="Organization" placeholder="Ideaforge Technologies" />
// // //             <Field label="Email" type="email" placeholder="you@company.com" />
// // //             <Field label="Mobile" placeholder="+91 98xxxxxx23" />
// // //             <Field label="Location" placeholder="Visakhapatnam, AP" />
// // //             <Field label="Industry" placeholder="EV / Drones / IoT..." />

// // //             {/* Conditionally show GSTIN and DPIIT fields */}
// // //             {showBusinessFields && (
// // //               <>
// // //                 <Field label="GSTIN" optional placeholder="29ABCDE1234F1Z5" />
// // //                 <Field label="DPIIT Number" optional placeholder="DIPP-XXXXX" />
// // //               </>
// // //             )}
// // //           </div>

// // //           {/* Password field with eye icon */}
// // //           <div className="mb-6">
// // //             <label className="block">
// // //               <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
// // //               <div className="relative">
// // //                 <input
// // //                   type={showPassword ? "text" : "password"}
// // //                   placeholder="Minimum 8 characters"
// // //                   className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
// // //                 />
// // //                 <button
// // //                   type="button"
// // //                   onClick={() => setShowPassword(!showPassword)}
// // //                   className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
// // //                 >
// // //                   {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
// // //                 </button>
// // //               </div>
// // //             </label>
// // //           </div>

// // //           <div className="flex items-center justify-between flex-wrap gap-4">
// // //             <p className="text-sm text-gray-500">
// // //               By continuing you agree to the ProtoHub Terms.
// // //             </p>
// // //             <button
// // //               type="submit"
// // //               className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition"
// // //             >
// // //               Continue →
// // //             </button>
// // //           </div>
// // //         </form>
// // //       </main>
// // //     </div>
// // //   );
// // // }

// // // function Field({ label, optional, ...props }) {
// // //   return (
// // //     <label className="block">
// // //       <span className="block text-sm font-medium text-gray-700 mb-1.5">
// // //         {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
// // //       </span>
// // //       <input
// // //         {...props}
// // //         className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// // //       />
// // //     </label>
// // //   );
// // // }



// // import { useState } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User, Eye, EyeOff, ChevronDown } from "lucide-react";
// // import authService from "../service/authService";

// // const innovatorTypes = [
// //   { id: "startup", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
// //   { id: "msme", icon: Building2, title: "MSME", subtitle: "Small & medium" },
// //   { id: "student", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
// //   { id: "researcher", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
// //   { id: "industry", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
// //   { id: "innovator", icon: User, title: "Innovator", subtitle: "Individual" },
// // ];

// // const roleOptions = [
// //   { id: "Innovator", label: "Innovator" },
// //   { id: "vendor", label: "Vendor" },
// //   { id: "expert", label: "Expert" },
// // ];

// // export default function Register() {
// //   const navigate = useNavigate();
// //   const [selectedType, setSelectedType] = useState("startup");
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [selectedRole, setSelectedRole] = useState("Innovator");
// //   const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");

// //   // Form fields
// //   const [formData, setFormData] = useState({
// //     name: "",
// //     organization: "",
// //     email: "",
// //     mobile: "",
// //     location: "",
// //     industry: "",
// //     gstin: "",
// //     dpiit: "",
// //     password: "",
// //   });

// //   // Check if GSTIN and DPIIT should be shown
// //   const showBusinessFields = selectedType !== "student" &&
// //     selectedType !== "researcher" &&
// //     selectedType !== "innovator";

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: value }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setError("");
// //     setSuccess("");
// //     setLoading(true);

// //     try {
// //       // Prepare request body based on role
// //       let requestBody = {};

// //       if (selectedRole === "Innovator") {
// //         // User/Innovator registration
// //         requestBody = {
// //           name: formData.name,
// //           email: formData.email,
// //           mobileNumber: formData.mobile,
// //           password: formData.password,
// //         };
// //       } else if (selectedRole === "vendor") {
// //         // Vendor registration
// //         requestBody = {
// //           name: formData.name,
// //           email: formData.email,
// //           mobileNumber: formData.mobile,
// //           password: formData.password,
// //           businessName: formData.organization, // Organization field maps to businessName
// //         };
// //       } else if (selectedRole === "expert") {
// //         // Expert registration - using same structure as user for now
// //         // When API is available, update this
// //         requestBody = {
// //           name: formData.name,
// //           email: formData.email,
// //           mobileNumber: formData.mobile,
// //           password: formData.password,
// //           // Add expert specific fields when available
// //         };
// //       }

// //       const response = await authService.register(requestBody, selectedRole);

// //       if (response.success) {
// //         setSuccess("Registration successful! Redirecting to login...");
// //         setTimeout(() => {
// //           navigate("/login");
// //         }, 1500);
// //       } else {
// //         setError(response.message || "Registration failed. Please try again.");
// //       }
// //     } catch (err) {
// //       setError(err.message || "Registration failed. Please check your details and try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-50">
// //       {/* Top bar */}
// //       <header className="bg-white border-b border-gray-100">
// //         <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
// //           <Link to="/" className="flex items-center gap-3">
// //             <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
// //               <Layers className="text-white w-4 h-4" />
// //             </div>
// //             <div>
// //               <p className="font-bold text-gray-900 leading-tight">
// //                 APIC <span className="text-indigo-600">ProtoHub</span>
// //               </p>
// //               <p className="text-[10px] tracking-wide text-gray-500 leading-tight">
// //                 ANDHRA PRADESH
// //               </p>
// //             </div>
// //           </Link>

// //           <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
// //             <Link to="/facilities" className="hover:text-indigo-600">Explore Facilities</Link>
// //             <a href="#machines" className="hover:text-indigo-600">Machines</a>
// //             <a href="#how-it-works" className="hover:text-indigo-600">How It Works</a>
// //             <Link to="/app/dashboard" className="hover:text-indigo-600">For Innovators</Link>
// //             <Link to="/admin" className="hover:text-indigo-600">APIC Admin</Link>
// //           </nav>
// //           <p className="text-sm text-gray-600">
// //             Already have an account?{" "}
// //             <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
// //               Sign in
// //             </Link>
// //           </p>
// //         </div>
// //       </header>

// //       <main className="max-w-4xl mx-auto px-6 py-12">
// //         <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
// //           Create your ProtoHub account
// //         </h1>
// //         <p className="text-gray-600 mb-8">
// //           Choose your innovator type to personalize your workspace.
// //         </p>

// //         {/* Role Dropdown */}
// //         <div className="mb-6">
// //           <label className="block text-sm font-medium text-gray-700 mb-1.5">
// //             Register as
// //           </label>
// //           <div className="relative">
// //             <button
// //               type="button"
// //               onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
// //               className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm flex items-center justify-between hover:border-indigo-300 transition"
// //             >
// //               <span>{selectedRole}</span>
// //               <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isRoleDropdownOpen ? "rotate-180" : ""}`} />
// //             </button>

// //             {isRoleDropdownOpen && (
// //               <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
// //                 {roleOptions.map((role) => (
// //                   <button
// //                     key={role.id}
// //                     type="button"
// //                     onClick={() => {
// //                       setSelectedRole(role.id);
// //                       setIsRoleDropdownOpen(false);
// //                     }}
// //                     className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${
// //                       selectedRole === role.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
// //                     }`}
// //                   >
// //                     {role.label}
// //                   </button>
// //                 ))}
// //               </div>
// //             )}
// //           </div>
// //           <p className="text-xs text-gray-400 mt-1">
// //             {selectedRole === "Innovator" && "Register as an innovator to start prototyping"}
// //             {selectedRole === "vendor" && "Register as a vendor to provide services"}
// //             {selectedRole === "expert" && "Register as an expert to consult"}
// //           </p>
// //         </div>

// //         {/* Innovator type cards */}
// //         <div className="grid sm:grid-cols-3 gap-4 mb-8">
// //           {innovatorTypes.map(({ id, icon: Icon, title, subtitle }) => {
// //             const isSelected = selectedType === id;
// //             return (
// //               <button
// //                 key={id}
// //                 type="button"
// //                 onClick={() => setSelectedType(id)}
// //                 className={`text-left rounded-2xl border p-5 transition ${isSelected
// //                     ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
// //                     : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
// //                   }`}
// //               >
// //                 <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
// //                 <p className="font-bold">{title}</p>
// //                 <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
// //                   {subtitle}
// //                 </p>
// //               </button>
// //             );
// //           })}
// //         </div>

// //         {/* Error/Success messages */}
// //         {error && (
// //           <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
// //             {error}
// //           </div>
// //         )}
// //         {success && (
// //           <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl text-green-600 text-sm">
// //             {success}
// //           </div>
// //         )}

// //         {/* Form card */}
// //         <form className="bg-white border border-gray-100 rounded-2xl p-8" onSubmit={handleSubmit}>
// //           <div className="grid sm:grid-cols-2 gap-6 mb-6">
// //             <Field
// //               label="Full name"
// //               name="name"
// //               value={formData.name}
// //               onChange={handleInputChange}
// //               placeholder="Arjun Reddy"
// //               required
// //             />
// //             <Field
// //               label="Organization"
// //               name="organization"
// //               value={formData.organization}
// //               onChange={handleInputChange}
// //               placeholder="Ideaforge Technologies"
// //               required={selectedRole === "vendor"} // Organization is required for vendor
// //             />
// //             <Field
// //               label="Email"
// //               type="email"
// //               name="email"
// //               value={formData.email}
// //               onChange={handleInputChange}
// //               placeholder="you@company.com"
// //               required
// //             />
// //             <Field
// //               label="Mobile"
// //               name="mobile"
// //               value={formData.mobile}
// //               onChange={handleInputChange}
// //               placeholder="+91 98xxxxxx23"
// //               required
// //             />
// //             <Field
// //               label="Location"
// //               name="location"
// //               value={formData.location}
// //               onChange={handleInputChange}
// //               placeholder="Visakhapatnam, AP"
// //             />
// //             <Field
// //               label="Industry"
// //               name="industry"
// //               value={formData.industry}
// //               onChange={handleInputChange}
// //               placeholder="EV / Drones / IoT..."
// //             />

// //             {/* Conditionally show GSTIN and DPIIT fields */}
// //             {showBusinessFields && (
// //               <>
// //                 <Field
// //                   label="GSTIN"
// //                   optional
// //                   name="gstin"
// //                   value={formData.gstin}
// //                   onChange={handleInputChange}
// //                   placeholder="29ABCDE1234F1Z5"
// //                 />
// //                 <Field
// //                   label="DPIIT Number"
// //                   optional
// //                   name="dpiit"
// //                   value={formData.dpiit}
// //                   onChange={handleInputChange}
// //                   placeholder="DIPP-XXXXX"
// //                 />
// //               </>
// //             )}
// //           </div>

// //           {/* Password field with eye icon */}
// //           <div className="mb-6">
// //             <label className="block">
// //               <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
// //               <div className="relative">
// //                 <input
// //                   type={showPassword ? "text" : "password"}
// //                   name="password"
// //                   value={formData.password}
// //                   onChange={handleInputChange}
// //                   placeholder="Minimum 8 characters"
// //                   required
// //                   className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
// //                 />
// //                 <button
// //                   type="button"
// //                   onClick={() => setShowPassword(!showPassword)}
// //                   className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
// //                 >
// //                   {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
// //                 </button>
// //               </div>
// //             </label>
// //           </div>

// //           <div className="flex items-center justify-between flex-wrap gap-4">
// //             <p className="text-sm text-gray-500">
// //               By continuing you agree to the ProtoHub Terms.
// //             </p>
// //             <button
// //               type="submit"
// //               disabled={loading}
// //               className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
// //             >
// //               {loading ? (
// //                 <>
// //                   <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
// //                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
// //                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
// //                   </svg>
// //                   Registering...
// //                 </>
// //               ) : (
// //                 "Continue →"
// //               )}
// //             </button>
// //           </div>
// //         </form>
// //       </main>
// //     </div>
// //   );
// // }

// // function Field({ label, optional, ...props }) {
// //   return (
// //     <label className="block">
// //       <span className="block text-sm font-medium text-gray-700 mb-1.5">
// //         {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
// //       </span>
// //       <input
// //         {...props}
// //         className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
// //       />
// //     </label>
// //   );
// // }






// import { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User, Eye, EyeOff, ChevronDown } from "lucide-react";
// import authService from "../service/authService";
// import Navbar from "../components/landingPage/Navbar";
// // ✅ All innovator types
// const allInnovatorTypes = [
//   { id: "startup", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
//   { id: "msme", icon: Building2, title: "MSME", subtitle: "Small & medium" },
//   { id: "student", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
//   { id: "researcher", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
//   { id: "industry", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
// ];

// // ✅ Types shown for each role
// const roleBasedTypes = {
//   Innovator: ["startup", "msme", "student", "researcher"], // All 5
//   vendor: ["startup", "msme", "researcher", "industry"], // Only business types
//   expert: ["startup", "msme", "researcher", "industry"], // All 5
// };

// const roleOptions = [
//   { id: "Innovator", label: "Innovator" },
//   { id: "vendor", label: "Vendor" },
//   { id: "expert", label: "Expert" },
// ];

// export default function Register() {
//   const navigate = useNavigate();
//   const [selectedType, setSelectedType] = useState("startup");
//   const [showPassword, setShowPassword] = useState(false);
//   const [selectedRole, setSelectedRole] = useState("Innovator");
//   const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Form fields
//   const [formData, setFormData] = useState({
//     name: "",
//     organization: "",
//     email: "",
//     mobile: "",
//     location: "",
//     industry: "",
//     gstin: "",
//     dpiit: "",
//     password: "",
//   });

//   // ✅ Get the types to show based on selected role
//   const getVisibleTypes = () => {
//     const typeIds = roleBasedTypes[selectedRole] || [];
//     return allInnovatorTypes.filter(type => typeIds.includes(type.id));
//   };

//   // ✅ Show business fields for all except student and researcher
//   const showBusinessFields = selectedType !== "student" &&
//     selectedType !== "researcher";

//   // ✅ Hide industry field when role is Innovator
//   const showIndustryField = selectedRole !== "Innovator";

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");
//     setLoading(true);

//     try {
//       let requestBody = {};

//       if (selectedRole === "Innovator") {
//         requestBody = {
//           name: formData.name,
//           email: formData.email,
//           mobileNumber: formData.mobile,
//           password: formData.password,
//         };
//       } else if (selectedRole === "vendor") {
//         requestBody = {
//           name: formData.name,
//           email: formData.email,
//           mobileNumber: formData.mobile,
//           password: formData.password,
//           businessName: formData.organization,
//         };
//       } else if (selectedRole === "expert") {
//         requestBody = {
//           name: formData.name,
//           email: formData.email,
//           mobileNumber: formData.mobile,
//           password: formData.password,
//         };
//       }

//       const response = await authService.register(requestBody, selectedRole);

//       if (response.success) {
//         setSuccess("Registration successful! Redirecting to login...");
//         setTimeout(() => {
//           navigate("/");
//         }, 1500);
//       } else {
//         setError(response.message || "Registration failed. Please try again.");
//       }
//     } catch (err) {
//       setError(err.message || "Registration failed. Please check your details and try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Get visible types
//   const visibleTypes = getVisibleTypes();

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Top bar */}
//       <header className="bg-white border-b border-gray-100">
//         <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
//           <Link to="/" className="flex items-center gap-3 cursor-pointer">
//             <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
//               <Layers className="text-white w-5 h-5" />
//             </div>
//             <div>
//               <p className="font-bold text-gray-900 leading-tight">
//                 APIC <span className="text-indigo-600">ProtoHub</span>
//               </p>
//               <p className="text-[11px] tracking-wide text-gray-500 leading-tight">
//                 ANDHRA PRADESH
//               </p>
//             </div>
//           </Link>

//           <nav className="hidden lg:flex items-center gap-10 text-[15px] font-medium text-slate-600">
//             <Link to="/" className="hover:text-indigo-600 transition">
//               Home
//             </Link>

//             <Link to="/AboutAPIC" className="hover:text-indigo-600 transition">
//               About APIC
//             </Link>

//             <Link to="/Innovatorshome" className="hover:text-indigo-600 transition">
//               Innovators
//             </Link>

//             <Link to="/Facilitieshomepage" className="hover:text-indigo-600 transition">
//               Facilities
//             </Link>

//             <Link to="/machineMarketplace" className="hover:text-indigo-600 transition">
//               Machines
//             </Link>

//             <Link to="/ExpertConnect" className="hover:text-indigo-600 transition">
//               Experts
//             </Link>

//             {/* <Link to="/events" className="hover:text-indigo-600 transition">
//             Events & Programs
//           </Link> */}

//             {/* <Link to="/howitsworksdata" className="hover:text-indigo-600 transition">
//             How it works
//           </Link> */}
//           </nav>
//           <p className="text-sm text-gray-600">
//             Already have an account?{" "}
//             <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
//               Sign in
//             </Link>
//           </p>
//         </div>
//       </header>

//       <main className="max-w-4xl mx-auto px-6 py-12">
//         <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
//           Create your ProtoHub account
//         </h1>
//         <p className="text-gray-600 mb-8">
//           Choose your innovator type to personalize your workspace.
//         </p>

//         {/* Role Dropdown */}
//         <div className="mb-6">
//           <label className="block text-sm font-medium text-gray-700 mb-1.5">
//             Register as
//           </label>
//           <div className="relative">
//             <button
//               type="button"
//               onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//               className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm flex items-center justify-between hover:border-indigo-300 transition"
//             >
//               <span>{selectedRole}</span>
//               <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isRoleDropdownOpen ? "rotate-180" : ""}`} />
//             </button>

//             {isRoleDropdownOpen && (
//               <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
//                 {roleOptions.map((role) => (
//                   <button
//                     key={role.id}
//                     type="button"
//                     onClick={() => {
//                       setSelectedRole(role.id);
//                       setIsRoleDropdownOpen(false);
//                     }}
//                     className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${selectedRole === role.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
//                       }`}
//                   >
//                     {role.label}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//           <p className="text-xs text-gray-400 mt-1">
//             {selectedRole === "Innovator" && "Register as an innovator to start prototyping"}
//             {selectedRole === "vendor" && "Register as a vendor to provide services"}
//             {selectedRole === "expert" && "Register as an expert to consult"}
//           </p>
//         </div>

//         {/* ✅ Dynamic innovator type cards - changes based on role */}
//         <div className="grid sm:grid-cols-4 gap-4 mb-8">
//           {visibleTypes.map(({ id, icon: Icon, title, subtitle }) => {
//             const isSelected = selectedType === id;
//             return (
//               <button
//                 key={id}
//                 type="button"
//                 onClick={() => setSelectedType(id)}
//                 className={`text-left rounded-2xl border p-5 transition ${isSelected
//                   ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
//                   : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
//                   }`}
//               >
//                 <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
//                 <p className="font-bold">{title}</p>
//                 <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
//                   {subtitle}
//                 </p>
//               </button>
//             );
//           })}
//         </div>

//         {/* Error/Success messages */}
//         {error && (
//           <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
//             {error}
//           </div>
//         )}
//         {success && (
//           <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl text-green-600 text-sm">
//             {success}
//           </div>
//         )}

//         {/* Form card */}
//         <form className="bg-white border border-gray-100 rounded-2xl p-8" onSubmit={handleSubmit}>
//           <div className="grid sm:grid-cols-2 gap-6 mb-6">
//             <Field
//               label="Full name"
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               placeholder="Arjun Reddy"
//               required
//             />
//             <Field
//               label="Organization"
//               name="organization"
//               value={formData.organization}
//               onChange={handleInputChange}
//               placeholder="Ideaforge Technologies"
//               required={selectedRole === "vendor"}
//             />
//             <Field
//               label="Email"
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleInputChange}
//               placeholder="you@company.com"
//               required
//             />
//             <Field
//               label="Mobile"
//               name="mobile"
//               value={formData.mobile}
//               onChange={handleInputChange}
//               placeholder="+91 98xxxxxx23"
//               required
//             />

//             <Field
//               label="Location"
//               name="location"
//               value={formData.location}
//               onChange={handleInputChange}
//               placeholder="Visakhapatnam, AP"
//             />

//             {/* ✅ Conditionally show Industry field - hide when role is Innovator */}
//             {showIndustryField && (
//               <Field
//                 label="Industry"
//                 name="industry"
//                 value={formData.industry}
//                 onChange={handleInputChange}
//                 placeholder="EV / Drones / IoT..."
//               />
//             )}

//             {/* Conditionally show GSTIN and DPIIT fields */}
//             {showBusinessFields && (
//               <>
//                 <Field
//                   label="GSTIN"
//                   optional
//                   name="gstin"
//                   value={formData.gstin}
//                   onChange={handleInputChange}
//                   placeholder="29ABCDE1234F1Z5"
//                 />
//                 <Field
//                   label="DPIIT Number"
//                   optional
//                   name="dpiit"
//                   value={formData.dpiit}
//                   onChange={handleInputChange}
//                   placeholder="DIPP-XXXXX"
//                 />
//               </>
//             )}
//           </div>

//           {/* Password field with eye icon */}
//           <div className="mb-6">
//             <label className="block">
//               <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
//               <div className="relative">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   name="password"
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   placeholder="Minimum 8 characters"
//                   required
//                   className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
//                 >
//                   {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                 </button>
//               </div>
//             </label>
//           </div>

//           <div className="flex items-center justify-between flex-wrap gap-4">
//             <p className="text-sm text-gray-500">
//               By continuing you agree to the ProtoHub Terms.
//             </p>
//             <button
//               type="submit"
//               disabled={loading}
//               className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {loading ? (
//                 <>
//                   <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Registering...
//                 </>
//               ) : (
//                 "Continue →"
//               )}
//             </button>
//           </div>
//         </form>
//       </main>
//     </div>
//   );
// }

// function Field({ label, optional, ...props }) {
//   return (
//     <label className="block">
//       <span className="block text-sm font-medium text-gray-700 mb-1.5">
//         {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
//       </span>
//       <input
//         {...props}
//         className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//       />
//     </label>
//   );
// }





import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layers, Rocket, Building2, GraduationCap, FlaskConical, Factory, User, Eye, EyeOff, ChevronDown } from "lucide-react";
import authService from "../service/authService";

// ✅ All innovator types
const allInnovatorTypes = [
  { id: "STARTUP", icon: Rocket, title: "Startup", subtitle: "DPIIT recognized" },
  { id: "MSME", icon: Building2, title: "MSME", subtitle: "Small & medium" },
  { id: "STUDENT_FACULTY", icon: GraduationCap, title: "Student / Faculty", subtitle: "University" },
  { id: "RESEARCHER", icon: FlaskConical, title: "Researcher", subtitle: "R&D institution" },
  { id: "INDUSTRY", icon: Factory, title: "Industry", subtitle: "Manufacturer" },
];

// ✅ Types shown for each role
const roleBasedTypes = {
  Innovator: ["STARTUP", "MSME", "STUDENT_FACULTY", "RESEARCHER"],
  vendor: ["STARTUP", "MSME", "RESEARCHER", "INDUSTRY"],
  expert: ["STARTUP", "MSME", "RESEARCHER", "INDUSTRY"],
};

const roleOptions = [
  { id: "Innovator", label: "Innovator" },
  { id: "vendor", label: "Vendor" },
  { id: "expert", label: "Expert" },
];

export default function Register() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("STARTUP");
  const [showPassword, setShowPassword] = useState(false);
  const [selectedRole, setSelectedRole] = useState("Innovator");
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Form fields
  // Register.jsx - Add new state fields for expert
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    email: "",
    mobile: "",
    location: "",
    industry: "",
    gstin: "",
    dpiit: "",
    aadharNumber: "",
    panNumber: "",
    password: "",
    // ✅ Expert specific fields
    specialization: "",
    qualification: "",
    about: "",
    experienceYears: "",
    available: true,
  });

  // ✅ Check if expert fields should be shown
  const showExpertFields = selectedRole === "expert";

  // ✅ Get the types to show based on selected role
  const getVisibleTypes = () => {
    const typeIds = roleBasedTypes[selectedRole] || [];
    return allInnovatorTypes.filter(type => typeIds.includes(type.id));
  };

  // ✅ Show business fields for all except student and researcher
  const showBusinessFields = selectedType !== "STUDENT_FACULTY" &&
    selectedType !== "RESEARCHER";

  // ✅ Hide industry field when role is Innovator
  const showIndustryField = selectedRole !== "Innovator";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      let requestBody = {};

      if (selectedRole === "Innovator") {
        requestBody = {
          name: formData.name,
          email: formData.email,
          mobileNumber: formData.mobile,
          password: formData.password,
          location: formData.location,
          aadharNumber: formData.aadharNumber,
          panNumber: formData.panNumber,
          gstin: formData.gstin,
          dpiitNumber: formData.dpiit,
          industry: formData.industry,
          userType: selectedType,
        };
      } else if (selectedRole === "vendor") {
        requestBody = {
          name: formData.name,
          email: formData.email,
          mobileNumber: formData.mobile,
          password: formData.password,
          businessName: formData.organization,
        };
      } else if (selectedRole === "expert") {
        requestBody = {
          fullName: formData.name,
          userType: selectedType,
          organization: formData.organization,
          email: formData.email,
          mobile: formData.mobile,
          location: formData.location,
          gstin: formData.gstin || "",
          dpiitNumber: formData.dpiit || "",
          password: formData.password,
          specialization: formData.specialization,
          qualification: formData.qualification,
          about: formData.about,
          experienceYears: parseInt(formData.experienceYears) || 0,
          available: true,
        };
      }

      const response = await authService.register(requestBody, selectedRole);
      console.log("Registration response:", response);

      // ✅ Fix: Check for expertId (with 't')
      const isSuccess =
        response.success === true ||
        response.expertId ||
        response.id ||
        response.userId ||
        response.data?.id ||
        response.data?.expertId;

      if (isSuccess) {
        setSuccess("Registration successful! Redirecting to login...");
        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else {
        setError(response.message || "Registration failed. Please try again.");
      }
    } catch (err) {
      console.error("Registration error:", err);
      setError(err.message || "Registration failed. Please check your details and try again.");
    } finally {
      setLoading(false);
    }
  };

  // Get visible types
  const visibleTypes = getVisibleTypes();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top bar */}
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Layers className="text-white w-5 h-5" />
            </div>
            <div>
              <p className="font-bold text-gray-900 leading-tight">
                APIC <span className="text-indigo-600">ProtoHub</span>
              </p>
              <p className="text-[11px] tracking-wide text-gray-500 leading-tight">
                ANDHRA PRADESH
              </p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-10 text-[15px] font-medium text-slate-600">
            <Link to="/" className="hover:text-indigo-600 transition">Home</Link>
            <Link to="/AboutAPIC" className="hover:text-indigo-600 transition">About APIC</Link>
            <Link to="/Innovatorshome" className="hover:text-indigo-600 transition">Innovators</Link>
            <Link to="/Facilitieshomepage" className="hover:text-indigo-600 transition">Facilities</Link>
            <Link to="/machineMarketplace" className="hover:text-indigo-600 transition">Machines</Link>
            <Link to="/ExpertConnect" className="hover:text-indigo-600 transition">Experts</Link>
          </nav>
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="text-indigo-600 font-semibold hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">
          Create your ProtoHub account
        </h1>
        <p className="text-gray-600 mb-8">
          Choose your innovator type to personalize your workspace.
        </p>

        {/* Role Dropdown */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Register as
          </label>
          <div className="relative">
            <button
              type="button"
              onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
              className="w-full bg-white border border-gray-200 rounded-xl px-4 py-2.5 text-sm flex items-center justify-between hover:border-indigo-300 transition"
            >
              <span>{selectedRole}</span>
              <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isRoleDropdownOpen ? "rotate-180" : ""}`} />
            </button>

            {isRoleDropdownOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden">
                {roleOptions.map((role) => (
                  <button
                    key={role.id}
                    type="button"
                    onClick={() => {
                      setSelectedRole(role.id);
                      setIsRoleDropdownOpen(false);
                    }}
                    className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 transition ${selectedRole === role.id ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
                      }`}
                  >
                    {role.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          <p className="text-xs text-gray-400 mt-1">
            {selectedRole === "Innovator" && "Register as an innovator to start prototyping"}
            {selectedRole === "vendor" && "Register as a vendor to provide services"}
            {selectedRole === "expert" && "Register as an expert to consult"}
          </p>
        </div>

        {/* ✅ Dynamic innovator type cards - changes based on role */}
        <div className="grid sm:grid-cols-4 gap-4 mb-8">
          {visibleTypes.map(({ id, icon: Icon, title, subtitle }) => {
            const isSelected = selectedType === id;
            return (
              <button
                key={id}
                type="button"
                onClick={() => setSelectedType(id)}
                className={`text-left rounded-2xl border p-5 transition ${isSelected
                  ? "bg-gradient-to-br from-indigo-600 to-purple-600 border-transparent text-white"
                  : "bg-white border-gray-200 text-gray-900 hover:border-indigo-300"
                  }`}
              >
                <Icon className={`w-6 h-6 mb-6 ${isSelected ? "text-white" : "text-indigo-600"}`} />
                <p className="font-bold">{title}</p>
                <p className={`text-sm ${isSelected ? "text-indigo-100" : "text-gray-500"}`}>
                  {subtitle}
                </p>
              </button>
            );
          })}
        </div>

        {/* Error/Success messages */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
            {error}
          </div>
        )}
        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl text-green-600 text-sm">
            {success}
          </div>
        )}

        {/* Form card */}
        <form className="bg-white border border-gray-100 rounded-2xl p-8" onSubmit={handleSubmit}>
          <div className="grid sm:grid-cols-2 gap-6 mb-6">
            <Field
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="John Dee"
              required
            />
            <Field
              label="Organization"
              name="organization"
              value={formData.organization}
              onChange={handleInputChange}
              placeholder="Ideaforge Technologies"
              required={selectedRole === "vendor"}
            />
            <Field
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="you@company.com"
              required
            />
            <Field
              label="Mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              placeholder="+91 98xxxxxx23"
              required
            />

            <Field
              label="Location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              placeholder="Visakhapatnam, AP"
            />

            {/* ✅ Conditionally show Industry field - hide when role is Innovator */}
            {showIndustryField && (
              <Field
                label="Industry"
                name="industry"
                value={formData.industry}
                onChange={handleInputChange}
                placeholder="EV / Drones / IoT..."
              />
            )}

            {/* Aadhar Number */}
            <Field
              label="Aadhar Number"
              optional
              name="aadharNumber"
              value={formData.aadharNumber}
              onChange={handleInputChange}
              placeholder="1234 5678 9012"
            />

            {/* PAN Number */}
            <Field
              label="PAN Number"
              optional
              name="panNumber"
              value={formData.panNumber}
              onChange={handleInputChange}
              placeholder="ABCDE1234F"
            />

            {/* Conditionally show GSTIN and DPIIT fields */}
            {showBusinessFields && (
              <>
                <Field
                  label="GSTIN"
                  optional
                  name="gstin"
                  value={formData.gstin}
                  onChange={handleInputChange}
                  placeholder="29ABCDE1234F1Z5"
                />
                <Field
                  label="DPIIT Number"
                  optional
                  name="dpiit"
                  value={formData.dpiit}
                  onChange={handleInputChange}
                  placeholder="DIPP-XXXXX"
                />
              </>
            )}
          </div>
          {/* Expert Specific Fields */}
          {showExpertFields && (
            <div className="border-t border-gray-200 pt-6 mt-6">
              <p className="text-sm font-semibold text-gray-700 mb-4">Expert Details</p>
              <div className="grid sm:grid-cols-2 gap-6">
                <Field
                  label="Specialization"
                  name="specialization"
                  value={formData.specialization}
                  onChange={handleInputChange}
                  placeholder="e.g., Additive Manufacturing, Robotics"
                  required={selectedRole === "expert"}
                />
                <Field
                  label="Qualification"
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleInputChange}
                  placeholder="e.g., Ph.D., M.Tech, B.E."
                  required={selectedRole === "expert"}
                />
                <Field
                  label="Experience (Years)"
                  name="experienceYears"
                  type="number"
                  value={formData.experienceYears}
                  onChange={handleInputChange}
                  placeholder="e.g., 10"
                  required={selectedRole === "expert"}
                />
                <div className="sm:col-span-2">
                  <Field
                    label="About / Bio"
                    name="about"
                    value={formData.about}
                    onChange={handleInputChange}
                    placeholder="Tell us about your expertise and experience..."
                    textarea={true}
                    required={selectedRole === "expert"}
                  />
                </div>
              </div>
            </div>
          )}


          {/* Password field with eye icon */}
          <div className="mb-6">
            <label className="block">
              <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Minimum 8 characters"
                  required
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </label>
          </div>

          <div className="flex items-center justify-between flex-wrap gap-4">
            <p className="text-sm text-gray-500">
              By continuing you agree to the ProtoHub Terms.
            </p>
            <button
              type="submit"
              disabled={loading}
              className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-6 py-3 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Registering...
                </>
              ) : (
                "Continue →"
              )}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}

function Field({ label, optional, type = "text", textarea = false, ...props }) {
  return (
    <label className="block">
      <span className="block text-sm font-medium text-gray-700 mb-1.5">
        {label} {optional && <span className="text-gray-400 font-normal">(optional)</span>}
      </span>
      {textarea ? (
        <textarea
          {...props}
          rows={3}
          className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
        />
      ) : (
        <input
          type={type}
          {...props}
          className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        />
      )}
    </label>
  );
}